{
  "courses": {
    "title": "Courses",
    "description": "Subjects with their modules and lessons.",
    "pupilDescription": "Courses with lessons available to you.",
    "searchPlaceholder": "Search courses…",
    "filter": {
      "label": "Show",
      "active": "Active",
      "archived": "Archived",
      "all": "All"
    },
    "archivedBadge": "Archived",
    "counts": "Modules: {{modules}} · Lessons: {{lessons}}",
    "empty": {
      "title": "No courses yet",
      "manageText": "Create your first course to start building lessons.",
      "pupilText": "Courses your teachers publish to your classes appear here, with their lessons.",
      "filterText": "Nothing matches the current filters."
    },
    "create": {
      "button": "Create course",
      "title": "Create a course",
      "description": "Name the subject — modules and lessons come next.",
      "titleLabel": "Course title",
      "titlePlaceholder": "e.g. Mathematics, Grade 7",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Optional — what this course covers",
      "submit": "Create course",
      "submitting": "Creating…",
      "success": "Course created",
      "failed": "Could not create the course"
    },
    "edit": {
      "button": "Edit course",
      "title": "Edit course",
      "description": "Rename the course or change what it covers.",
      "submit": "Save changes",
      "submitting": "Saving…",
      "success": "Course updated",
      "failed": "Could not save the course"
    }
  },
  "standalone": {
    "title": "Standalone lessons",
    "description": "Lessons that do not belong to any course.",
    "empty": "No standalone lessons yet.",
    "newLessonTitle": "New lesson title",
    "create": "Create lesson"
  },
  "course": {
    "back": "Back to courses",
    "noDescription": "No description",
    "lessons": "Lessons",
    "noLessons": "No lessons here yet.",
    "noVisibleLessons": "No lessons are available to you in this course yet.",
    "courseLessons": "Course lessons",
    "courseLessonsDescription": "Lessons that sit directly under the course, outside any module.",
    "newLessonTitle": "New lesson title",
    "addLesson": "Add lesson",
    "addModuleTitle": "Add a module",
    "newModuleTitle": "New module title",
    "addModule": "Add module",
    "editLesson": "Edit {{title}}",
    "moveModuleUp": "Move {{title}} up",
    "moveModuleDown": "Move {{title}} down",
    "moveLessonUp": "Move lesson {{title}} up",
    "moveLessonDown": "Move lesson {{title}} down",
    "lessonNumber": "Lesson {{n}}:",
    "module": {
      "rename": "Rename {{title}}",
      "renameLabel": "Module title",
      "renameSubmit": "Save",
      "delete": "Delete {{title}}",
      "deleteTitle": "Delete the module “{{title}}”?",
      "deleteDescription_zero": "The module has no lessons, so nothing else changes.",
      "deleteDescription_one": "Its 1 lesson is NOT deleted — it moves to the course level and stays available. Only the module itself goes.",
      "deleteDescription_other": "Its {{count}} lessons are NOT deleted — they move to the course level and stay available. Only the module itself goes.",
      "deleteConfirm": "Delete module",
      "deleted": "Module deleted"
    },
    "archive": {
      "button": "Archive course",
      "title": "Archive {{title}}?",
      "description": "The course and its lessons stop being editable, but stay readable. Archiving cannot be undone from the app.",
      "success": "Course archived"
    }
  },
  "status": {
    "draft": "Draft",
    "published": "Published",
    "archived": "Archived"
  },
  "blocks": {
    "rich_text": "Text",
    "image": "Image",
    "video": "Video",
    "audio": "Audio",
    "file": "File",
    "youtube": "YouTube",
    "link": "Link",
    "divider": "Divider"
  },
  "editor": {
    "title": "Lesson editor",
    "back": "Back",
    "view": "View",
    "publish": "Publish",
    "unpublish": "Unpublish",
    "duplicate": "Duplicate",
    "schedule": "Schedule",
    "archive": "Archive",
    "lessonTitle": "Lesson title",
    "course": "Course",
    "noCourse": "No course",
    "module": "Module",
    "noModule": "No module",
    "teacherNotes": "Teacher notes (private)",
    "teacherNotesHint": "Private lesson plan and notes. Pupils never see this — it is not part of the lesson content.",
    "save": "Save lesson",
    "saved": "Lesson saved",
    "saveFailed": "Could not save the lesson",
    "unsaved": "Unsaved changes",
    "published": "Lesson published",
    "unpublished": "Lesson moved back to draft",
    "duplicated": "Lesson duplicated — you are now editing the copy",
    "archived": "Lesson archived",
    "archiveTitle": "Archive {{title}}?",
    "archiveDescription": "The lesson disappears for pupils immediately. Archiving cannot be undone from the app.",
    "leaveTitle": "Discard unsaved changes?",
    "leaveDescription": "Your latest edits have not been saved and will be lost.",
    "leaveConfirm": "Leave without saving",
    "blocksErrors": "Some blocks need fixing:",
    "blocks": {
      "empty": "No content yet — add your first block below.",
      "add": "Add block",
      "moveUp": "Move block up",
      "moveDown": "Move block down",
      "delete": "Delete block"
    },
    "toolbar": {
      "bold": "Bold",
      "italic": "Italic",
      "underline": "Underline",
      "strike": "Strikethrough",
      "h2": "Heading 2",
      "h3": "Heading 3",
      "bulletList": "Bullet list",
      "orderedList": "Numbered list",
      "blockquote": "Quote",
      "codeBlock": "Code block",
      "link": "Link",
      "linkUrl": "Link URL",
      "linkApply": "Apply",
      "table": "Table",
      "tableRow": "Row",
      "tableColumn": "Column",
      "tableAddRow": "Add row below",
      "tableDeleteRow": "Delete row",
      "tableAddColumn": "Add column right",
      "tableDeleteColumn": "Delete column",
      "tableHeaderRow": "Header row",
      "tableDelete": "Delete table"
    },
    "asset": {
      "upload": "Upload",
      "replace": "Replace",
      "uploading": "Uploading… {{percent}}%",
      "progressLabel": "Upload progress",
      "caption": "Caption",
      "label": "Label",
      "hint": {
        "image": "JPEG, PNG, GIF or WebP, up to 50 MB.",
        "video": "MP4, WebM or QuickTime, up to 50 MB.",
        "audio": "MP3, MP4/AAC, OGG, WAV or WebM, up to 50 MB.",
        "file": "Documents, spreadsheets, presentations, text or ZIP, up to 50 MB."
      }
    },
    "youtube": {
      "url": "YouTube URL or video ID",
      "invalid": "Enter a valid YouTube video URL or an 11-character ID.",
      "previewTitle": "YouTube video preview",
      "caption": "Caption"
    },
    "link": {
      "url": "URL",
      "label": "Label"
    }
  },
  "schedule": {
    "title": "Schedule lesson",
    "description": "Slot this lesson into a class calendar. Pupils see it once the lesson is published.",
    "classLabel": "Class",
    "classPlaceholder": "Choose a class",
    "noClasses": "No active classes to schedule to — create a class first.",
    "startsAt": "Starts at",
    "duration": "Duration (minutes)",
    "submit": "Schedule",
    "success": "Lesson scheduled",
    "validation": "Choose a class and a start time"
  },
  "view": {
    "back": "Back",
    "edit": "Edit",
    "teacherNotes": "Teacher notes",
    "teacherNotesHint": "Visible to staff only — pupils never see these notes.",
    "empty": "This lesson has no content yet.",
    "assetUnavailable": "Attachment unavailable.",
    "download": "Download",
    "youtubeTitle": "YouTube video"
  },
  "validation": {
    "titleRequired": "Title is required"
  }
}
